import { Component, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

import { CourseService } from 'src/app/services/course.service';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize } from 'rxjs/operators';
import { NgbRatingConfig } from '@ng-bootstrap/ng-bootstrap';
import { ShareService } from 'src/app/services/share.service';
import { allCategory, CourseInfo } from 'src/app/model/course.model';


@Component({
  selector: 'app-courses',
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.scss']
})

export class CoursesComponent implements OnInit {
  allCategory: allCategory[] = [];
  categoryVisDetails: CourseInfo;

  currentRate: number;
  role = '';
  get permissions() {
    return JSON.parse(localStorage.getItem("permissions"));
  }
  constructor(
    private courseService: CourseService,
    private router: Router,
    private ns: NotificationService,
    rateConfig: NgbRatingConfig,
    private shareService: ShareService) {
    rateConfig.readonly = true;
    this.role  = localStorage.getItem('role');
    
  }

  ngOnInit() {
    let val = '';
    this.getAllCourses();
    this.onChangeCategory(val);
  }
  loader = false;
  getAllCourses() {
    this.loader = true;
    this.courseService.categoryAPI().pipe(finalize(() => {
      this.loader = false;
    })).subscribe(data => {
      this.allCategory = data;
    });
  }


  onChangeCategory(value) {
    // this.loader = true;
    // this.courseService.categoryVisCourses(value).pipe(finalize(() => {
    //   this.loader = false;
    // })).subscribe(courseDetails => {
    //   this.categoryVisDetails = courseDetails.courses_info;
    // })

  }

  sendEditDetails(id, course) {
   this.router.navigate(['/courses/add'], { queryParams: { courseId: id, course: course } });
  }

  sendCourseDetails(id, course) {
    this.router.navigate(['/courses/single-course'], { queryParams: { course_id: id, course: course } });
  }

  redirect(link){
    this.router.navigate([link]);
  }
  // Delete course
  delCourse(courseId) {
    this.loader = true;
    if (confirm("Are you sure you want to deactivate this course?")) {
      this.courseService.deactivateCourse(courseId).pipe(finalize(() => {
        this.loader = false;
      })).subscribe(req => {
        this.ns.showNotification("success", req.Status);
        this.onChangeCategory('');
      },
        (err) => {
          this.ns.showNotification("error", err.status);
        })
    }
  }
  makeCourseAvailableToall(courseId){
    if (confirm("Are you sure you want to make this course universal?")) {
    this.loader = true;
      this.courseService.makeCourseUniversalforTeach(courseId).pipe(finalize(() => {
        this.loader = false;
      })).subscribe(req => {
        this.ns.showNotification("success", req.message);
        this.onChangeCategory('');
      },
        (err) => {
          this.ns.showNotification("error", err.message);
        })
    }
  }

  findIndexOf(slug, pmenusSlug) {
    let indexOfValue;
    indexOfValue = this.shareService.getIndexArr(slug, pmenusSlug)
    return indexOfValue;
  }
}